import { cn } from '@/utils/cn'
import { getScoreRange } from '@/utils/getScoreRangeValue'
import { ThreeStepProgress } from '../charts/threeStepProgress'
import { ReputationTooltipContent } from '../shared/reputationTooltipContent'
import { Tooltip, TooltipContent } from './tooltip'

interface Props {
  score: number | null | undefined
  isNotRated?: boolean
  className?: string
}

export function ReputationTooltip({ score, isNotRated = false, className }: Props) {
  const range = score == null || isNotRated ? undefined : getScoreRange(score)

  return (
    <Tooltip
      tabIndex={-1}
      className={cn(
        'flex w-fit items-center justify-center gap-1 rounded-full border border-transparent bg-transparent p-0.5',
        'hocus:border-border hocus:bg-surface hocus:text-body-foreground',
        className
      )}
    >
      <ThreeStepProgress progress={range} />
      <TooltipContent>
        <ReputationTooltipContent score={score} scoreRange={range} isNotRated={isNotRated} />
      </TooltipContent>
    </Tooltip>
  )
}
